// Pencocokan substring tidak bisa memakai index, jadi query yang terlalu pendek
// mahal dan hasilnya tidak berguna. Field di bawah ambang ini tidak dikirim.
export const MIN_SEARCH_LENGTH = 2

/**
 * Menyiapkan satu isian form untuk dikirim sebagai query param.
 * Mengembalikan string kosong kalau isiannya belum layak dikirim, supaya
 * pemanggil tinggal membuang yang kosong -- `&fullname=` bikin URL kotor dan
 * cache key-nya beda-beda untuk hasil yang sama.
 */
export const normalizeSearchValue = (value, { stripSpaces = false } = {}) => {
  const trimmed = String(value ?? '').trim()
  const cleaned = stripSpaces ? trimmed.replace(/\s+/g, '') : trimmed
  return cleaned.length >= MIN_SEARCH_LENGTH ? cleaned : ''
}

// NIK sering ditempel dengan spasi di antara kelompok angkanya.
export const normalizeSearch = ({ fullname, nik, email } = {}) => ({
  fullname: normalizeSearchValue(fullname),
  nik: normalizeSearchValue(nik, { stripSpaces: true }),
  email: normalizeSearchValue(email),
})

export const EMPTY_SEARCH = { fullname: '', nik: '', email: '' }

export const hasSearch = (search) =>
  Object.values(normalizeSearch(search)).some(Boolean)
